var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.showLoader)?_c('AppLoader',{ref:"loader",on:{"complete":_vm.onLoaded}}):_vm._e(),_vm._v(" "),_c('AppHeader'),_vm._v(" "),_c('Nuxt')],1)}
var staticRenderFns = []

export { render, staticRenderFns }